module.exports = "/images/SelectArrow.svg";